import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UiActions } from './ui.actions';
import { map, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectSidebarCollapsed } from './ui.selectors';

@Injectable()
export class UiEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  persistSidebarCollapsed$ = createEffect(
    () =>
      this.store.select(selectSidebarCollapsed).pipe(
        tap((collapsed) => {
          try {
            localStorage.setItem('ui.sidebarCollapsed', JSON.stringify(collapsed));
          } catch {}
        }),
      ),
    { dispatch: false },
  );

  hydrateSidebarCollapsed$ = createEffect(() =>
    this.actions$.pipe(
      ofType('@ngrx/effects/init'),
      map(() => {
        try {
          const raw = localStorage.getItem('ui.sidebarCollapsed');
          const collapsed = raw ? (JSON.parse(raw) as boolean) : false;
          return UiActions.setSidebarCollapsed({ collapsed });
        } catch {
          return UiActions.setSidebarCollapsed({ collapsed: false });
        }
      }),
    ),
  );
}
